const topics = [
    {
      title: "Adding Fun",
      slug: "addingfun",
      standardNumber: "NC.1.OA.1",
      description: "Operations and Algebraic Thinking",
      gameType: "countPop",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Taking Away",
      slug: "takingaway",
      standardNumber: "NC.1.OA.2",
      description: "Operations and Algebraic Thinking",
      gameType: "talkChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Adding Properties",
      slug: "addingproperties",
      standardNumber: "NC.1.OA.3",
      description: "Operations and Algebraic Thinking",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Understand the equal sign",
      slug: "understandtheequalsign",
      standardNumber: "NC.1.OA.7",
      description: "Operations and Algebraic Thinking",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Count to 50",
      slug: "countto50",
      standardNumber: "NC.1.NBT.1",
      description: "Number and Operations in Base Ten",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Count from 50 to 100",
      slug: "countfrom50to100",
      standardNumber: "NC.1.NBT.1",
      description: "Number and Operations in Base Ten",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Count from 100 to 150",
      slug: "countfrom100to150",
      standardNumber: "NC.1.NBT.1",
      description: "Number and Operations in Base Ten",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Count By 10's",
      slug: "countby10s",
      standardNumber: "NC.1.NBT.2",
      description: "Number and Operations in Base Ten",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Greater Than",
      slug: "greaterthan",
      standardNumber: "NC.1.NBT.3",
      description: "Number and Operations in Base Ten",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Short, Long, Line Them Up",
      slug: "shortlonglinethemup",
      standardNumber: "NC.1.MD.1",
      description: "Measurement and Data",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Non-Standard",
      slug: "nonstandard",
      standardNumber: "NC.1.MD.2",
      description: "Measurement and Data",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Telling time",
      slug: "tellingtime",
      standardNumber: "NC.1.MD.3",
      description: "Measurement and Data",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Dollars & Cents",
      slug: "dollarscents",
      standardNumber: "NC.1.MD.5",
      description: "Measurement and Data",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Bar Graph",
      slug: "bargraph",
      standardNumber: "NC.1.MD.4",
      description: "Measurement and Data",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Pictograph",
      slug: "pictograph",
      standardNumber: "NC.1.MD.4",
      description: "Measurement and Data",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Shapes",
      slug: "shapes",
      standardNumber: "NC.1.G.1",
      description: "Geometry",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Build It Flat",
      slug: "builditflat",
      standardNumber: "NC.1.G.2",
      description: "Geometry",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Cut It Equal",
      slug: "cutitequal",
      standardNumber: "NC.1.G.3",
      description: "Geometry",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Half of, Fourth of",
      slug: "halfoffourthof",
      standardNumber: "NC.1.G.3",
      description: "Geometry",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "Whole Again",
      slug: "wholeagain",
      standardNumber: "NC.1.G.3",
      description: "Geometry",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    }
  ]
  ;
export default topics;